// Registro central de módulos para permisos por usuario (candados).
// Las claves coinciden con las rutas (sin "/") en App.js / Layout.jsx.
export const MODULE_GROUPS = [
  { title: "General", items: [{ key: "dashboard", label: "Dashboard" }] },
  { title: "Ventas", items: [
    { key: "pos", label: "Punto de Venta" },
    { key: "checador", label: "Checador de Precios" },
    { key: "caja", label: "Mi Caja" },
    { key: "sales", label: "Historial de Ventas" },
    { key: "returns", label: "Devoluciones" },
    { key: "cotizaciones", label: "Cotizaciones" },
    { key: "whatsapp", label: "Ventas WhatsApp" },
    { key: "timbres", label: "Facturación (CFDI)" },
    { key: "tarjetas", label: "Tarjetas de lealtad y monedero" },
    { key: "cajas", label: "Cajas de Cajeros" },
  ]},
  { title: "Inventario", items: [
    { key: "inventory", label: "Inventario" },
    { key: "promociones", label: "Promociones" },
    { key: "batches", label: "Lotes y Caducidades" },
    { key: "purchases", label: "Compras" },
    { key: "envios", label: "Envíos Plataformas" },
    { key: "shopify", label: "Shopify (pedidos y stock)" },
    { key: "multiempresa", label: "Multiempresa (traspasos entre empresas)" },
  ]},
  { title: "Finanzas", items: [
    { key: "bank", label: "Banco y Caja Fuerte" },
    { key: "gastos", label: "Gastos" },
    { key: "nomina", label: "Nómina" },
    { key: "finanzas", label: "Préstamos e Inversión" },
    { key: "presupuestos", label: "Presupuestos" },
    { key: "reportes", label: "Reportes" },
  ]},
  { title: "Relaciones", items: [{ key: "customers", label: "Clientes" }] },
  { title: "Organización", items: [
    { key: "tareas", label: "Tareas y Calendario" },
    { key: "asistencia", label: "Checador de Asistencia" },
    { key: "users", label: "Usuarios" },
    { key: "settings", label: "Configuración" },
  ]},
];

export const ALL_KEYS = MODULE_GROUPS.flatMap((g) => g.items.map((i) => i.key));

// Vista operativa por defecto de un cajero (compatibilidad con usuarios previos sin permisos definidos)
export const CASHIER_DEFAULT = ["dashboard", "pos", "checador", "caja", "sales", "returns", "cotizaciones", "timbres", "inventory", "batches", "bank", "presupuestos", "customers", "tareas"];

export function resolvePerms(user) {
  if (!user) return [];
  if (user.role === "admin" || user.role === "superadmin") return ALL_KEYS;
  return Array.isArray(user.permissions) && user.permissions.length
    ? user.permissions
    : (user.role === "manager" ? ALL_KEYS : CASHIER_DEFAULT);
}

// Módulos habilitados por el plan de la licencia (vacío = sin restricción / licencias antiguas)
export function planAllows(user, key) {
  if (!user || user.role === "superadmin") return true;
  const mods = user.license?.modules;
  if (!Array.isArray(mods) || !mods.length) return true;
  return mods.includes(key) || key === "miplan";
}

// El plan de la licencia NO incluye el módulo (pero el usuario sí tendría permiso): se muestra con candado
export function planLocked(user, key) {
  if (!user || user.role === "superadmin" || planAllows(user, key)) return false;
  return user.role === "admin" || resolvePerms(user).includes(key);
}

export function hasModule(user, key) {
  if (!user) return false;
  if (user.role === "superadmin") return true;
  if (!planAllows(user, key)) return false;
  if (user.role === "admin") return true;
  return resolvePerms(user).includes(key);
}

// Primera ruta permitida (para landing / redirecciones cuando falta un módulo)
export function firstAllowedPath(user) {
  if (!user) return "/login";
  if (user.role === "superadmin") return "/licenses";
  const perms = resolvePerms(user);
  const first = ALL_KEYS.find((k) => perms.includes(k) && planAllows(user, k)) || perms.find((k) => planAllows(user, k));
  return first ? `/${first}` : "/login";
}
